import React from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  success: {
    color: theme.palette.success.main,
  },
  warning: {
    color: theme.palette.warning.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  info: {
    color: theme.palette.info.main,
  },
  primary: {
    color: theme.palette.primary.main,
  },
}));

// COMPONENT
function LabelStatus({ status, className, children, ...rest }) {
  const { classes, cx } = useStyles();
  return (
    <Typography className={cx(classes[status], className)} {...rest}>
      {children}
    </Typography>
  );
}

export default LabelStatus;
